export default "__VITE_ASSET__CnSu65P7__"